import {WidgetSettings} from '../../../components/layout/widget/widget-settings';
import {WidgetSettingsDefinition} from '../../../components/layout/widget/widget-settings-definition';
import {ChartCommonSettings} from './chart-common-settings';

export const CHART_WIDGET_SETTINGS_VERSION: string = '1.0.0';

export interface ChartWidgetSettings extends WidgetSettings, ChartCommonSettings {
    isConfirmationEnabled: boolean;
}

export interface ChartWidgetSettingsDef
    extends WidgetSettingsDefinition, Omit<ChartCommonSettings, 'securityKey' | 'keepVisibleTimeRange'> {
    version: string;
    securityKeyStr: string;
    keepVisibleTimeRange?: boolean;
    isConfirmationEnabled: boolean;
}
